import type { ServerResponse } from "@/http"
import type { IUnredeemedPackageResponse } from "@/types"
import { axios } from "@/axios"
import { UnredeemedPackage } from "@/models"

interface IQueryParams {
  page?: number
  perPage?: number
  orderByDesc?: boolean
}

interface IListUnredeemedPackagesMeta {
  UnredeemedCount?: number
}

export async function listUnredeemedPackages({ page, perPage, orderByDesc }: IQueryParams = {}, hostAccountId?: number) {
  const query = new URLSearchParams()

  if (page)
    query.append("page", page.toString())

  if (perPage)
    query.append("perPage", perPage.toString())

  if (orderByDesc)
    query.append("orderByDesc", orderByDesc.toString())

  const endpoint = hostAccountId
    ? `api/host/packages?status=unredeemed&hostAccountId=${hostAccountId}&${query.toString()}`
    : `api/host/packages?status=unredeemed&${query.toString()}`

  const response = await axios.get<ServerResponse<IUnredeemedPackageResponse[], IListUnredeemedPackagesMeta>>(endpoint)

  const meta = {
    unredeemedCount: response.data.Meta?.UnredeemedCount ?? 0,
  }

  return {
    packages: response.data.Data?.map(unredeemedPackage => UnredeemedPackage.fromResponse(unredeemedPackage)) ?? [],
    links: response.data.Links,
    meta,
  }
}
